import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseResponse } from 'ccc-commons/dist/core';
import { Role } from '../models/role.model';
import { tap } from 'rxjs/operators';
import { LoginAsStoreService } from '../store/login-as.store.service';

@Injectable()
export class LoginAsService {

  apiUrl = environment.apiUrl + '/loginas';

  constructor(private http: HttpClient, private loginStore: LoginAsStoreService) { }

  addLoginAs(accountId: string): Observable<HttpResponse<BaseResponse<Role>>> {
    return this.http.post<BaseResponse<Role>>(`${this.apiUrl}/${accountId}`, '', { observe: 'response' })
      .pipe(
        tap( resp => {
          if (resp && resp.ok) {
            this.loginStore.assumedId = accountId;
            this.loginStore.hideMessage.next(true);
          }
        })
      );
  }

  removeLoginAs(): Observable<HttpResponse<BaseResponse<Role>>> {
    return this.http.delete<BaseResponse<Role>>(this.apiUrl, { observe: 'response' })
      .pipe(
        tap( resp => {
          if (resp && resp.ok) {
            this.loginStore.hideMessage.next(false);
          }
        })
      );
  }
}
